import { buildQueryString } from '@izimi/utils';

import type FetchService from '../FetchService';
import type { ApiRequestQueryParamType } from '../types';
import type { GetHistoryLogsResponse } from './types';

class HistoryLogApi {
  constructor(private fetchService: FetchService) {}

  getHistoryLogsV3(params: ApiRequestQueryParamType<'getHistoryLogsV3'>) {
    const qs = buildQueryString(params);
    return this.fetchService.get<GetHistoryLogsResponse>(`/v3/history${qs}`);
  }
}

export default HistoryLogApi;
